var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 13.5,
    fill: "#E7E0F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 9,
    cy: 7,
    r: 7,
    fill: "#E7E0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 24L22.6334 16.4667L20.7 14.5333L15.0667 20.1667L12.2667 17.3667L10.3667 19.2667L15.1 24ZM8.50004 29.3333C7.76671 29.3333 7.13893 29.0722 6.61671 28.55C6.09449 28.0278 5.83337 27.4 5.83337 26.6667V5.33332C5.83337 4.59999 6.09449 3.97221 6.61671 3.44999C7.13893 2.92777 7.76671 2.66666 8.50004 2.66666H19.1667L27.1667 10.6667V26.6667C27.1667 27.4 26.9056 28.0278 26.3834 28.55C25.8612 29.0722 25.2334 29.3333 24.5 29.3333H8.50004ZM17.8334 12V5.33332H8.50004V26.6667H24.5V12H17.8334Z",
    fill: "#873CAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementsIcon);
export default __webpack_public_path__ + "static/media/engagements_icon.39fd72f37dedb89f2d25e428c662396a.svg";
export { ForwardRef as ReactComponent };